import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import authSelector from 'modules/Auth/selectors'
import roleSelector from 'modules/Roles/selectors'
import moment from 'moment'
import SuccessMessage from 'utils/SuccessMessage'
import authRequest from 'utils/authRequest'
import { systemConfig } from 'utils/config'
import corporateRequest from 'utils/corporateRequest'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import elasticSearchSyncRequest from 'utils/elasticSearchSyncRequest'
import instituteRequest from 'utils/instituteRequest'
import studentRequest from 'utils/studentRequest'
import selectors from './selectors'
import { stream } from 'xlsx'
const currentDate = moment().format('YYYY-MM-DD')

export const SET_CORPORATE_METRICS_DATA = 'corporate/SET_CORPORATE_METRICS_DATA'
export const SET_JOBS_LIST = 'corporate/SET_JOBS_LIST'
export const SET_PROMOTION_DATA = 'corporate/SET_PROMOTION_DATA'
export const SET_EVALUATION_DATA = 'corporate/SET_EVALUATION_DATA'
export const SET_QUESTIONNAIRE_DATA = 'corporate/SET_QUESTIONNAIRE_DATA'
export const SET_STDALGO_DATA = 'corporate/SET_STDALGO_DATA'
export const SET_PREVIEW_ROLE_DATA = 'corporate/SET_PREVIEW_ROLE_DATA'
export const SET_CURRENT_JOB_ID = 'corporate/SET_CURRENT_JOB_ID'
export const SET_INSTITUTES_LIST = 'corporate/SET_INSTITUTES_LIST'
export const SET_INSTITUTES_LOCATION_LIST =
  'corporate/SET_INSTITUTES_LOCATION_LIST'
export const SET_SINGLE_ROLE_DATA = 'corporate/SET_SINGLE_ROLE_DATA'
export const SET_COURSE_DATA = 'corporate/SET_COURSE_DATA'
export const SET_ROLE_DETAILS = 'corporate/SET_ROLE_DETAILS'
export const SET_EDITING_ROLE = 'corporate/SET_EDITING_ROLE'
export const SET_DRIVE_DATA = 'corporate/SET_DRIVE_DATA'
export const SET_APPLIED_COLLEGES_LIST = 'corporate/SET_APPLIED_COLLEGES_LIST'
export const SET_APPLIED_CANDIDATES_LIST =
  'corporate/SET_APPLIED_CANDIDATES_LIST'
export const SET_APPLIED_CANDIDATES_LIST_TRUE =
  'corporate/SET_APPLIED_CANDIDATES_LIST_TRUE'
export const SET_LIST_OF_DEGREE = 'corporate/SET_LIST_OF_DEGREE'
export const SET_SKILLS_LIST = 'corporate/SET_SKILLS_LIST'
export const SET_RANKING_CONFIG_DATA = 'corporate/SET_RANKING_CONFIG_DATA'
export const SET_CITIES_LIST = 'corporate/SET_CITIES_LIST'
export const SET_INSTITUTE_CAMPUS_DETAILS =
  'corporate/SET_INSTITUTE_CAMPUS_DETAILS'
export const SET_DRIVE_LIST = 'corporate/SET_DRIVE_LIST'
export const SET_DRIVE_ROLE_METRICS = 'corporate/SET_DRIVE_ROLE_METRICS'
export const SET_DESIGNATION_LIST = 'corporate/SET_DESIGNATION_LIST'
export const SET_FUNCTIONS_LIST = 'corporate/SET_FUNCTIONS_LIST'
export const SET_EDIT_ROLE_ON_VIEW = 'corporate/SET_EDIT_ROLE_ON_VIEW'
export const SET_CANDIDATE_DETAILS = 'corporate/SET_CANDIDATE_DETAILS'
export const SET_ROLE_APPLIED_DRIVE_METRICS =
  'corporate/SET_ROLE_APPLIED_DRIVE_METRICS'
export const SET_INDUSTRIES_LIST = 'corporate/SET_INDUSTRIES_LIST'
export const SET_SPECIALISATION_LIST = 'corporate/SET_SPECIALISATION_LIST'
export const SET_JOB_ROLE_CAMPUS_LIST = 'corporate/SET_JOB_ROLE_CAMPUS_LIST'
export const SET_DEGREES_BASED_ON_ROLES = 'corporate/SET_DEGREES_BASED_ON_ROLES'
export const SET_DEGREES_BASED_EX_ROLES = 'corporate/SET_DEGREES_BASED_EX_ROLES'
export const SET_DEGREES_BASED_ON_ATS = 'corporate/SET_DEGREES_BASED_ON_ATS'
export const SET_COLLEGE_BASED_ON_QB = 'corporate/SET_COLLEGE_BASED_ON_QB'
export const SET_DEGREE_BASED_ON_QB = 'corporate/SET_DEGREE_BASED_ON_QB'
export const SET_COLLEGE_BASED_ON_ATS = 'corporate/SET_COLLEGE_BASED_ON_ATS'
export const SET_LOCATION_BASED_ON_ATS = 'corporate/SET_LOCATION_BASED_ON_ATS'
export const SET_DRIVE_CREATED_CANDIDATE =
  'corporate/SET_DRIVE_CREATED_CANDIDATE'
export const SET_DRIVE_CREATED_CANDIDATE_PREVIEW =
  'corporate/SET_DRIVE_CREATED_CANDIDATE_PREVIEW'
export const SET_DRIVE_NOT_CREATED_CANDIDATE =
  'corporate/SET_DRIVE_NOT_CREATED_CANDIDATE'

export const SET_ROLE_VIEW_CHART = 'corporate/SET_ROLE_VIEW_CHART'
export const SET_YEAR_OF_PASSING = 'corporate/SET_YEAR_OF_PASSING'
export const SET_ROLE_VIEW_CARD = 'corporate/SET_ROLE_VIEW_CARD'
export const SET_ROLE_VIEW_CARD_ATS = 'corporate/SET_ROLE_VIEW_CARD_ATS'

export const SET_RESCHEDULE_LIST = 'corporate/SET_RESCHEDULE_LIST'

export const SET_ROLES_ROUNDS = 'corporate/SET_ROLES_ROUNDS'
export const SET_ROLE_CITY = 'corporate/SET_ROLE_CITY'

export const SET_ALL_QUESTIONARIELIST_LIST =
  'corporate/SET_ALL_QUESTIONARIELIST_LIST'

export const SET_SINGLE_QUESTIONARIE = 'corporate/SET_SINGLE_QUESTIONARIE'

export const SET_ALL_QUESTION_BANK_LIST = 'corporate/SET_ALL_QUESTION_BANK_LIST'
export const SET_ROLE_DATA_TO_EXCEL = 'corporate/SET_ROLE_DATA_TO_EXCELS'
export const SET_APPLICANT_CANDIDATE_LIST =
  'corporate/SET_APPLICANT_CANDIDATE_LIST'
export const SET_QUESTIONNIER_CANDIDATE_LIST =
  'corporate/SET_QUESTIONNIER_CANDIDATE_LIST'

export const SET_DRAFT_DATA = `corporate/SET_DRAFT_DATA`
export const SET_ELASTIC_SEARCH_DEGREE_DATA = `SET_ELASTIC_SEARCH_DEGREE_DATA`
export const SET_LIST_OF_LOCATION = `corporate/SET_LIST_OF_LOCATION`

export const setElasticSearchDegreeData = data => {
  return {
    type: SET_ELASTIC_SEARCH_DEGREE_DATA,
    data,
  }
}
export const setDraftData = data => {
  return {
    type: SET_DRAFT_DATA,
    data,
  }
}

export const setRoleCityData = data => {
  return {
    type: SET_ROLE_CITY,
    data,
  }
}
export const setCorporateMetricsData = data => {
  return {
    type: SET_CORPORATE_METRICS_DATA,
    data,
  }
}
export const setRoleDataToExcel = data => {
  return {
    type: SET_ROLE_DATA_TO_EXCEL,
    data,
  }
}
export const setJobsList = data => {
  return {
    type: SET_JOBS_LIST,
    data,
  }
}

export const setPromotionData = data => {
  return {
    type: SET_PROMOTION_DATA,
    data,
  }
}

export const setEvaluationDetails = data => {
  return {
    type: SET_EVALUATION_DATA,
    data,
  }
}

export const setQuestionnaireDetails = data => {
  return {
    type: SET_QUESTIONNAIRE_DATA,
    data,
  }
}

export const setStdRankData = data => {
  return {
    type: SET_STDALGO_DATA,
    data,
  }
}

export const setPreviewRoleData = data => {
  return {
    type: SET_PREVIEW_ROLE_DATA,
    data,
  }
}
export const setCurrentJobId = id => {
  return {
    type: SET_CURRENT_JOB_ID,
    id,
  }
}
export const setInstitutesList = obj => {
  return {
    type: SET_INSTITUTES_LIST,
    obj,
  }
}
export const setInstitutesLocationList = obj => {
  return {
    type: SET_INSTITUTES_LOCATION_LIST,
    obj,
  }
}
export const setSingleRoleData = obj => {
  return {
    type: SET_SINGLE_ROLE_DATA,
    obj,
  }
}
export const setRoleDetails = obj => {
  return {
    type: SET_ROLE_DETAILS,
    obj,
  }
}
export const setEditingRole = value => {
  return {
    type: SET_EDITING_ROLE,
    value,
  }
}
export const setEditRoleOnView = value => {
  return {
    type: SET_EDIT_ROLE_ON_VIEW,
    value,
  }
}
export const setListOfDegree = value => {
  return {
    type: SET_LIST_OF_DEGREE,
    value,
  }
}

export const setDriveData = data => {
  return {
    type: SET_DRIVE_DATA,
    data,
  }
}

export const setAppliedCollegesList = data => {
  return {
    type: SET_APPLIED_COLLEGES_LIST,
    data,
  }
}
export const setAppliedCandidatesList = data => {
  return {
    type: SET_APPLIED_CANDIDATES_LIST,
    data,
  }
}

export const setAppliedCandidatesListTrue = data => {
  return {
    type: SET_APPLIED_CANDIDATES_LIST_TRUE,
    data,
  }
}
export const setSkillsList = data => {
  return {
    type: SET_SKILLS_LIST,
    data,
  }
}

export const setRankingConfigData = list => {
  return {
    type: SET_RANKING_CONFIG_DATA,
    list,
  }
}

export const setCityList = data => {
  return {
    type: SET_CITIES_LIST,
    data,
  }
}
export const setInstituteCampusDetails = data => {
  return {
    type: SET_INSTITUTE_CAMPUS_DETAILS,
    data,
  }
}
export const setDriveList = data => {
  return {
    type: SET_DRIVE_LIST,
    data,
  }
}
export const setDriveRoleMetrics = data => {
  return {
    type: SET_DRIVE_ROLE_METRICS,
    data,
  }
}
export const setDesignationsList = data => {
  return {
    type: SET_DESIGNATION_LIST,
    data,
  }
}
export const setFunctionsList = data => {
  return {
    type: SET_FUNCTIONS_LIST,
    data,
  }
}

export const setCandidateDetails = data => {
  return {
    type: SET_CANDIDATE_DETAILS,
    data,
  }
}
export const setRoleAppliedDriveMetrics = data => {
  return {
    type: SET_ROLE_APPLIED_DRIVE_METRICS,
    data,
  }
}
export const setIndustriesList = data => {
  return {
    type: SET_INDUSTRIES_LIST,
    data,
  }
}
export const setSpecialisationList = data => {
  return {
    type: SET_SPECIALISATION_LIST,
    data,
  }
}

export const setJobRoleCampusList = data => {
  return {
    type: SET_JOB_ROLE_CAMPUS_LIST,
    data,
  }
}
export const setApplicantCandidateList = data => {
  return {
    type: SET_APPLICANT_CANDIDATE_LIST,
    data,
  }
}
export const setQuestionnierDBList = data => {
  return {
    type: SET_QUESTIONNIER_CANDIDATE_LIST,
    data,
  }
}
export const setDegreesBasedOnRoles = data => {
  return {
    type: SET_DEGREES_BASED_ON_ROLES,
    data,
  }
}
export const setDegreesBasedExRoles = data => {
  return {
    type: SET_DEGREES_BASED_EX_ROLES,
    data,
  }
}
export const setDegreeBasedOnATS = data => {
  return {
    type: SET_DEGREES_BASED_ON_ATS,
    data,
  }
}

export const setCollegeBasedOnQuestionnier = data => {
  return {
    type: SET_COLLEGE_BASED_ON_QB,
    data,
  }
}

export const setDegreeBasedOnQuestionnier = data => {
  return {
    type: SET_DEGREE_BASED_ON_QB,
    data,
  }
}

export const setCollegeBasedOnATS = data => {
  return {
    type: SET_COLLEGE_BASED_ON_ATS,
    data,
  }
}

export const setLocationBasedOnATS = data => {
  return {
    type: SET_LOCATION_BASED_ON_ATS,
    data,
  }
}

export const setDriveCreatedCandidates = data => {
  return {
    type: SET_DRIVE_CREATED_CANDIDATE,
    data,
  }
}
export const setListOfLocation = data => {
  return {
    type: SET_LIST_OF_LOCATION,
    data,
  }
}

export const setDriveNotCreatedCandidates = data => {
  return {
    type: SET_DRIVE_NOT_CREATED_CANDIDATE,
    data,
  }
}

export const setDriveCreatedCandidatesPreview = data => {
  return {
    type: SET_DRIVE_CREATED_CANDIDATE_PREVIEW,
    data,
  }
}

export const setRoleViewChart = data => {
  return {
    type: SET_ROLE_VIEW_CHART,
    data,
  }
}
export const setYearOfPassing = data => {
  return {
    type: SET_YEAR_OF_PASSING,
    data,
  }
}

export const setRoleViewCard = data => {
  return {
    type: SET_ROLE_VIEW_CARD,
    data,
  }
}

export const setRoleViewCardATS = data => {
  return {
    type: SET_ROLE_VIEW_CARD_ATS,
    data,
  }
}

export const setRescheduleList = data => {
  return {
    type: SET_RESCHEDULE_LIST,
    data,
  }
}

export const setAllQuestionarieList = data => {
  return {
    type: SET_ALL_QUESTIONARIELIST_LIST,
    data,
  }
}

export const setAllQuestionBankList = data => {
  return {
    type: SET_ALL_QUESTION_BANK_LIST,
    data,
  }
}

export const setSingleQuestionarie = data => {
  return {
    type: SET_SINGLE_QUESTIONARIE,
    data,
  }
}

export const setRoleRounds = data => {
  return {
    type: SET_ROLES_ROUNDS,
    data,
  }
}
export const getRoleDraftData = jobId => async (dispatch, getState) => {
  const state = getState()
  const corporate_id = authSelector.getCorporateId(state)

  try {
    const result = await corporateRequest.get(
      `/corporates/${corporate_id}/jobs/draft/${jobId}`
    )
    dispatch(setDraftData(result?.data?.data || {}))
    dispatch(setEditingRole(true))
    dispatch(setCurrentJobId(result?.data?.data?.id || ''))
    return result
  } catch (error) {
    ErrorMessage(error?.message)
  }
}
export const getJobsList =
  ({
    searchValue,
    filterData,
    pageNum,
    sortby,
    orderby,
    limit = 10,
    setLoading,
  }) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)

    let SearchKey = searchValue ? `&searchBy=${searchValue.trim()}` : ''

    let jobtype = filterData?.jobType
      ? `&jobType=${filterData?.jobType?.trim()}`
      : ''
    let jobtypeLevel = ''
    if (filterData?.jobTypeLevel && filterData?.jobTypeLevel != 'INTERN') {
      jobtypeLevel = filterData?.jobTypeLevel
        ? `&jobTypeLevels=${filterData?.jobTypeLevel}`
        : ''
    } else {
      jobtypeLevel =
        filterData?.jobTypeLevel == 'INTERN' ? `&jobCategory=INTERNSHIP` : ''
    }

    let postedonStart = filterData?.postedOnStart
      ? `&postedOnStart=${filterData?.postedOnStart?.toString()}`
      : ''

    let postedonEnd = filterData?.postedOnEnd
      ? `&postedOnEnd=${filterData?.postedOnEnd?.toString()}`
      : ''
    let status = filterData?.status ? `&status=${filterData?.status}` : ''
    let pageNo = pageNum || 0
    let sort = sortby ? `&sort=${sortby}` : ''
    let orderBy = orderby ? `&orderBy=${orderby}` : ''

    try {
      setLoading(true)
      const res = await corporateRequest.get(
        `/corporates/${corporate_id}/jobs/lists?pageLimit=${limit}&pageNo=${pageNo}${SearchKey}${jobtype}${jobtypeLevel}${postedonStart}${postedonEnd}${status}${sort}${orderBy}`
      )
      dispatch(setJobsList(res?.data?.data || {}))
      dispatch(getCorporateMetricsData())
      dispatch(setAppliedCollegesList({}))
      setLoading(false)
    } catch (error) {
      setLoading(false)
      dispatch(setJobsList({}))
    }
  }
export const getCorporateMetricsData = () => async (dispatch, getState) => {
  const state = getState()
  const corporate_id = authSelector.getCorporateId(state)
  try {
    const res = await corporateRequest.get(
      `/corporates/${corporate_id}/jobs/metrics`
    )
    dispatch(setCorporateMetricsData(res?.data?.data || {}))
    return res
  } catch (error) {
    return error
  }
}
export const getYearOfPassing = searchValue => async (dispatch, getState) => {
  const state = getState()
  const corporate_id = authSelector.getCorporateId(state)
  const searchKey = searchValue ? `?search=${searchValue}` : ''
  try {
    const res = await corporateRequest.get(
      `/corporates/jobs/yearOfPassing${searchKey}`
    )
    dispatch(setYearOfPassing(res?.data?.data || {}))
    return res
  } catch (error) {
    return error
  }
}
export const getRoleCityData =
  ({ jobId, locationSearch, setLocationLoading, currentPage = 0 }) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    let SearchKey = locationSearch ? `&searchBy=${locationSearch}` : ''
    try {
      setLocationLoading(true)
      const res = await instituteRequest.get(
        `/institutes/corporate/${corporate_id}/jobRole/${jobId}/instituteLocation/list?pageNo=${currentPage}&pageLimit=100${SearchKey}`
      )
      dispatch(setRoleCityData(res?.data?.data || {}))
      setLocationLoading(false)
      return res
    } catch (error) {
      setLocationLoading(false)
      return error
    }
  }

export const newCorporateJobRoles =
  (data, isDraft = false) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    try {
      const result = await corporateRequest.post(
        `/corporates/${corporate_id}/job`,
        data
      )

      dispatch(setSingleRoleData(result?.data?.data || {}))
      dispatch(setDraftData(result?.data?.data || {}))
      dispatch(setPreviewRoleData(result?.data?.data || {}))
      dispatch(setCurrentJobId(result?.data?.data?.id || ''))
      window.history.replaceState(
        null,
        '',
        `/roles/new-role/${result?.data?.data?.id}`
      )
      const payload = {
        query_date: currentDate,
      }
      await elasticSearchSyncRequest.post(`/sync/student_crud_skill`, payload)
      await elasticSearchSyncRequest.post(`/sync/skill_master`, payload)

      if (isDraft) {
        SuccessMessage('Saved Successfully')
      }
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error?.response
    }
  }
export const getPreviewData = roleId => async (dispatch, getState) => {
  try {
    if (roleId) {
      const state = getState()
      const corporate_id = authSelector.getCorporateId(state)
      const result = await corporateRequest.get(`/corporates/jobs/${roleId}`)
      // dispatch(setPreviewRoleData(result?.data?.data || {}))
      return result?.data?.data
    } else {
      return {}
    }
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
    return error?.response
  }
}
export const getInstitutesList =
  ({
    searchValue = '',
    limit = 10,
    pageNum = 0,
    setLoading,
    locationValue = '',
    tierValue = '',
    specialisationIds,
    publishedOrNot = '',
    isForRole = false,
    tpoCollegeList = false,
    forFilter,
  }) =>
  async (dispatch, getState) => {
    setLoading(true)
    let SearchKey = searchValue ? `&searchBy=${searchValue}` : ''

    let pageNo = 0
    if (isForRole) {
      pageNo = pageNum
    } else {
      pageNo = searchValue ? 0 : pageNum
    }
    let location = locationValue ? `&location=${locationValue}` : ''
    let tier = tierValue ? `&tier=${tierValue}` : ''
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    const job_id = roleSelector.getCurrentJobId(state)
    let payload = {}
    payload = {
      ...payload,
      corporateId: corporate_id,
      roleId: job_id,
    }
    if (specialisationIds) {
      payload = { ...payload, SpecialisationIds: specialisationIds }
    }
    if (publishedOrNot) {
      payload = { ...payload, publishedOrNot }
    }
    if (tpoCollegeList) {
      payload = { ...payload, tpoCollegeList }
    }

    try {
      const res = await instituteRequest.post(
        `/institutes/campus/preview/list?pageLimit=${limit}&pageNo=${pageNo}${SearchKey}${location}${tier}`,
        payload
      )
      if (!forFilter) {
        dispatch(setInstitutesList(res?.data?.data || []))
      }
      setLoading(false)
      return res
    } catch (error) {
      setInstitutesList([])
      setLoading(false)
      return error?.response
    }
  }

export const getInstitutesLocationList =
  ({
    searchValue = '',
    setLoading,
    tierValue = '',
    searchLocation = '',
    specialisationIds,
    publishedOrNot = '',
    tpoCollegeList = false,
  }) =>
  async (dispatch, getState) => {
    let SearchKey = searchValue ? `&searchBy=${searchValue}` : ''
    let location = searchLocation ? `&location=${searchLocation}` : ''
    let tier = tierValue ? `&tier=${tierValue}` : ''
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    const job_id = roleSelector.getCurrentJobId(state)
    let payload = {}
    payload = {
      ...payload,
      corporateId: corporate_id,
      roleId: job_id,
    }
    if (specialisationIds) {
      payload = { ...payload, SpecialisationIds: specialisationIds }
    }
    if (publishedOrNot) {
      payload = { ...payload, publishedOrNot }
    }

    if (tpoCollegeList) {
      payload = { ...payload, tpoCollegeList }
    }
    try {
      const res = await instituteRequest.post(
        `/institutes/campus/location/list?${SearchKey}${tier}${location}`,
        payload
      )
      dispatch(setInstitutesLocationList(res?.data?.data) || {})
      setLoading(false)
      return res
    } catch (error) {
      setInstitutesList([])
      setLoading(false)
      return error?.response
    }
  }

export const publishCorporateJobRole =
  (payload, setLoading) => async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    const job_id = roleSelector.getCurrentJobId(state)

    try {
      const result = await corporateRequest.post(
        `/corporates/${corporate_id}/jobs/${job_id}/publish`,
        payload
      )

      SuccessMessage('Published successfully.')
      dispatch(getJobsList({ setLoading }))
      dispatch(getCorporateMetricsData())
      dispatch(setCurrentJobId(''))
      return result
    } catch (error) {
      return error?.response
    }
  }
export const postCorporateJobRole =
  (payload, setLoading) => async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    const job_id = roleSelector.getCurrentJobId(state)

    try {
      const result = await corporateRequest.post(
        `/corporates/${corporate_id}/jobs`,
        payload
      )

      SuccessMessage('Saved successfully.')
      dispatch(setRoleDetails(result?.data?.data || {}))
      // dispatch(getJobsList({ setLoading }))
      // dispatch(getCorporateMetricsData())
      // dispatch(setCurrentJobId(''))
      return result
    } catch (error) {
      return error?.response
    }
  }
export const updateJobRole = (payload, jobId,setButtonLoading) => async (dispatch, getState) => {
  const state = getState()
  const corporate_id = authSelector.getCorporateId(state)

  const job_id = jobId
  if(setButtonLoading){
    setButtonLoading(true)
  }

  try {
    const result = await corporateRequest.put(
      `/corporates/${corporate_id}/jobs/${job_id}`,
      payload
    )
    const skillPayload = {
      query_date: '1990-01-01',
    }
    await elasticSearchSyncRequest.post(
      `/sync/student_crud_skill`,
      skillPayload
    )
    await elasticSearchSyncRequest.post(`/sync/skill_master`, skillPayload)
    if(setButtonLoading){
      setButtonLoading(false)
    }
    return result
  } catch (error) {
    if(setButtonLoading){
    setButtonLoading(false)
  }
    ErrorMessage(error?.response?.data?.message)
    return error?.response
  }
}

export const editApplicationForm = (jobId, payload, setLoading) => async (dispatch, getState) => {
  const state = getState()
  const corporate_id = authSelector.getCorporateId(state)
  if (setLoading) setLoading(true)
  try {
    const result = await corporateRequest.put(
      `/corporates/${corporate_id}/jobs/${jobId}/application-form`,
      payload
    )
    if (setLoading) setLoading(false)
    SuccessMessage('Application form updated successfully')
    return result
  } catch (error) {
    if (setLoading) setLoading(false)
    ErrorMessage(error?.response?.data?.message || 'Failed to update application form')
    return error?.response
  }
}

export const updateCorporateJobRoles =
  (data, isDraft, fetchSingleRoleData) => async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    const job_id = roleSelector.getCurrentJobId(state)

    try {
      const result = await corporateRequest.put(
        `/corporates/${corporate_id}/jobs/${job_id}`,
        data
      )

      const payload = {
        query_date: currentDate,
      }
      await elasticSearchSyncRequest.post(`/sync/student_crud_skill`, payload)
      await elasticSearchSyncRequest.post(`/sync/skill_master`, payload)

      dispatch(setPreviewRoleData(result?.data?.data || {}))
      if (fetchSingleRoleData) {
        dispatch(setSingleRoleData(result?.data?.data || {}))
        dispatch(setDraftData(result?.data?.data || {}))
      }
      dispatch(setCurrentJobId(result?.data?.data?.id || ''))
      dispatch(setDraftData(result?.data?.data || {}))
      if (isDraft) {
        SuccessMessage('Saved Successfully')
      }
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error?.response
    }
  }

export const closeApplication =
  (jobId, setLoading) => async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)

    try {
      const result = await corporateRequest.post(
        `/corporates/${corporate_id}/jobs/${jobId}/close`,
        {}
      )

      dispatch(getJobsList({ setLoading }))
      dispatch(getCorporateMetricsData())
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }

export const duplicateRole = jobId => async (dispatch, getState) => {
  const state = getState()
  const corporate_id = authSelector.getCorporateId(state)

  try {
    const result = await corporateRequest.post(
      `/corporates/${corporate_id}/jobs/${jobId}/duplicate`
    )

    dispatch(getCorporateMetricsData())
    return result
  } catch (error) {
    ErrorMessage(error?.message)
  }
}
export const deleteRole = jobId => async (dispatch, getState) => {
  const state = getState()
  const corporate_id = authSelector.getCorporateId(state)

  try {
    const result = await corporateRequest.delete(
      `/corporates/${corporate_id}/jobs/${jobId}`
    )

    dispatch(getCorporateMetricsData())
    return result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
  }
}

export const getSingleRoleData =
  (degreeAndSkill = 1, jobId) =>
  async (dispatch, getState) => {
    const state = getState()

    const corporate_id = authSelector.getCorporateId(state)
    // const roleDetails = selectors.getRoleDetails(state)
    // const roleId = roleDetails?.jobRole?.id
    const job_id = jobId

    let url = `/corporates/${corporate_id}/jobs/${job_id}`
    if (!degreeAndSkill) {
      url = url + '?skillsRequired=0&degreeRequired=0'
    }
    dispatch(setSingleRoleData({}))
    try {
      const result = await corporateRequest.get(url)
      dispatch(setEditingRole(true))
      dispatch(setCurrentJobId(job_id || ''))
      dispatch(setSingleRoleData(result?.data?.data || {}))

      return result
    } catch (error) {
      dispatch(setSingleRoleData({}))
      //
    }
  }

const getPageNo = (searchValue, pageNum) => {
  if (searchValue) {
    return 0
  }
  return pageNum ? pageNum - 1 : 0
}

export const getAppliedCollegesList =
  ({
    roleId,
    searchValue,
    sortby,
    orderby,
    filterData,
    setLoading,
    cities,
    instituteCampusIds,
    pageLimit = 10,
    pageNum = 0,
  }) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    let searchKey = searchValue ? `&searchBy=${searchValue}` : ''

    let sort = sortby ? `&sort=${sortby}` : ''
    let orderBy = orderby ? `&order=${orderby}` : ''

    let city = filterData?.location ? `&cities=${filterData?.location}` : ''

    let SearchByCity = cities ? `&cities=${cities}` : ''

    let rankStart = filterData?.rankingStart
      ? `&rankingStart=${filterData?.rankingStart}`
      : ''
    let rankEnd = filterData?.rankingEnd
      ? `&rankingEnd=${filterData?.rankingEnd}`
      : ''
    let tier = filterData?.tiers ? `&tiers=${filterData?.tiers}` : ''
    let status = filterData?.status ? `&status=${filterData?.status}` : ''
    let candidateStart = filterData?.candidateStart
      ? `&candidateStart=${filterData?.candidateStart}`
      : ''
    let candidateEnd = filterData?.candidateEnd
      ? `&candidateEnd=${filterData?.candidateEnd}`
      : ''
    let driveStatus = filterData?.driveStatus
      ? `&driveStatus=${filterData?.driveStatus}`
      : ''

    let instituteIds = instituteCampusIds
      ? `&instituteCampusIds=${instituteCampusIds}`
      : ''

    let pageNo = getPageNo(searchValue, pageNum)

    try {
      setLoading(true)
      const result = await instituteRequest.get(
        `/institutes/instituteCampus/corporate/${corporate_id}/jobrole/${roleId}/list?pageLimit=${pageLimit}&pageNo=${pageNo}${searchKey}${sort}${orderBy}${city}${rankStart}${rankEnd}${tier}${candidateStart}${candidateEnd}${driveStatus}${SearchByCity}${instituteIds}${status}`
      )
      dispatch(setAppliedCollegesList(result?.data?.data || {}))
      setLoading(false)
      return result
    } catch (error) {
      setLoading(false)
      dispatch(setAppliedCollegesList({}))
      ErrorMessage(error?.message)
    }
  }

export const getDriveCreatedCandidates =
  ({
    roleId,
    location,
    setLoading,
    searchValue,
    instituteCampusIds = [],
    percentage,
    rating,
    degreeStreamMapIds,
    pageLimit,
    pageNo,
  }) =>
  async dispatch => {
    let payload = {
      type: 'DRIVE_CREATED',
    }
    if (instituteCampusIds?.length) {
      payload.instituteCampusIds = instituteCampusIds
    }
    if (location) {
      payload.location = location
    }
    if (rating) {
      payload.rating = rating
    }
    if (degreeStreamMapIds) {
      payload.degreeStreamMapIds = degreeStreamMapIds
    }
    if (percentage) {
      payload.percentage = percentage
    }
    let pageNoQ = pageNo
      ? `pageNo=${getPageNo(searchValue, pageNo)}`
      : `pageNo=0`
    let pageLimitQ = pageLimit ? `&pageLimit=${pageLimit}` : `&pageLimit=10`
    let query = `${pageNoQ}${pageLimitQ}`
    try {
      setLoading(true)
      const result = await studentRequest.post(
        `students/role/${roleId}/drive/jobRoleInstituteAndNameCount?${query}`,
        payload
      )
      dispatch(setDriveCreatedCandidates(result?.data?.data))
      setLoading(false)
      return result
    } catch (error) {
      setLoading(false)

      ErrorMessage(error?.message)
      dispatch(setDriveCreatedCandidates({}))
    }
  }
export const getDriveNotCreatedCandidates =
  ({
    roleId,
    location,
    setLoading,
    searchValue,
    instituteCampusIds = [],
    percentage,
    rating,
    degreeStreamMapIds,
    pageLimit,
    pageNo,
  }) =>
  async dispatch => {
    let payload = {
      type: 'DRIVE_NOT_CREATED',
    }
    if (instituteCampusIds?.length) {
      payload.instituteCampusIds = instituteCampusIds
    }
    if (location) {
      payload.location = location
    }
    if (rating) {
      payload.rating = rating
    }
    if (degreeStreamMapIds) {
      payload.degreeStreamMapIds = degreeStreamMapIds
    }
    if (percentage) {
      payload.percentage = percentage
    }

    let pageNoQ = pageNo
      ? `pageNo=${getPageNo(searchValue, pageNo)}`
      : `pageNo=0`
    let pageLimitQ = pageLimit ? `&pageLimit=${pageLimit}` : `&pageLimit=10`
    let query = `${pageNoQ}${pageLimitQ}`
    try {
      setLoading(true)
      const result = await studentRequest.post(
        `students/role/${roleId}/drive/jobRoleInstituteAndNameCount?${query}`,
        payload
      )
      dispatch(setDriveNotCreatedCandidates(result?.data))
      setLoading(false)
      return result
    } catch (error) {
      setLoading(false)

      ErrorMessage(error?.message)
      dispatch(setInstituteCampusDetails({}))
    }
  }

export const getDriveCreatedCandidatesPreview =
  ({
    roleId,
    location,
    setLoading,
    searchValue,
    instituteCampusIds = [],
    percentage,
    rating,
    degreeStreamMapIds,
    pageLimit,
    pageNo,
  }) =>
  async dispatch => {
    let payload = {
      type: 'DRIVE_CREATED',
    }
    if (instituteCampusIds?.length) {
      payload.instituteCampusIds = instituteCampusIds
    }
    if (location) {
      payload.location = location
    }
    if (rating) {
      payload.rating = rating
    }
    if (degreeStreamMapIds) {
      payload.degreeStreamMapIds = degreeStreamMapIds
    }
    if (percentage) {
      payload.percentage = percentage
    }

    let pageNoQ = pageNo
      ? `pageNo=${getPageNo(searchValue, pageNo)}`
      : `pageNo=0`
    let pageLimitQ = pageLimit ? `&pageLimit=${pageLimit}` : `&pageLimit=10`
    let query = `${pageNoQ}${pageLimitQ}`
    try {
      setLoading(true)
      const result = await studentRequest.post(
        `students/role/${roleId}/drive/jobRoleInstituteAndNameCount?${query}`,
        payload
      )
      dispatch(setDriveCreatedCandidatesPreview(result?.data?.data))
      setLoading(false)
      return result
    } catch (error) {
      setLoading(false)

      ErrorMessage(error?.message)
      dispatch(setDriveCreatedCandidatesPreview({}))
    }
  }

export const getAppliedCandidateList =
  ({
    roleId,
    setLoading,
    searchValue,
    sortby,
    orderby,
    filterData,
    searchByRating,
    searchByPercentage,
    searchByDegree,
    pageLimit = 10,
    pageNum = 0,
    instituteCampusIds,
    isListForDriveCreate = '',
    bulkDownload = 'false',
  }) =>
  async dispatch => {
    let rate = filterData?.rating?.minValue?.toString()
      ? `&fromRating=${filterData?.rating?.minValue?.toString()}`
      : ''
    let maxRate = filterData?.rating?.maxValue?.toString()
      ? `&toRating=${filterData?.rating?.maxValue?.toString()}`
      : ''
    let searchByRate = searchByRating ? `&rating=${searchByRating}` : ''

    let status = filterData?.status ? `&status=${filterData?.status}` : ''
    let payload = filterData?.degreeDepartment?.length
      ? {
          degreeStreamMapIds: filterData?.degreeDepartment?.toString(),
        }
      : searchByDegree?.length
      ? {
          degreeStreamMapIds: searchByDegree?.toString(),
        }
      : {}
    if (instituteCampusIds) {
      payload.instituteCampusIds = instituteCampusIds
    }
    let searchPercentage = searchByPercentage
      ? `&percentage=${searchByPercentage}`
      : ''

    let instituteIds = filterData?.collegeName
      ? `&instituteCampusIds=${filterData?.collegeName}`
      : ''
    let searchKey = searchValue ? `&searchBy=${searchValue.trim()}` : ''

    let gender = filterData?.gender ? `&gender=${filterData?.gender}` : ''
    let sort = sortby ? `&sort=${sortby}` : ''
    let orderBy = orderby ? `&order=${orderby}` : ''
    let isExpCandidate = `&isExpCandidate=${false}`
    let pageNo = searchValue ? 0 : pageNum ? pageNum - 1 : 0
    let isListForDriveCreateQ = isListForDriveCreate
      ? `&isListForDriveCreate=${isListForDriveCreate}`
      : ''
    let bulkDownloadStatus = bulkDownload === true ? `&bulkDownload=true` : ''
    try {
      setLoading(true)
      const result = await studentRequest.post(
        `/students/roles/${roleId}/candidate/list?pageLimit=${pageLimit}&pageNo=${pageNo}${searchKey}${sort}${orderBy}${status}${isExpCandidate}${instituteIds}${searchByRate}${searchPercentage}${gender}${isListForDriveCreateQ}${bulkDownloadStatus}`,
        payload
      )
      dispatch(setAppliedCandidatesList(result?.data?.data || {}))
      setLoading(false)
      return result
    } catch (error) {
      setLoading(false)
      dispatch(setAppliedCandidatesList({}))
      ErrorMessage(error?.message)
    }
  }

export const getListOfDegree =
  ({ searchValue }) =>
  async dispatch => {
    let SearchKey = searchValue ? `&search=${searchValue}` : ''

    try {
      const result = await instituteRequest.get(
        `institutes/search/degreeStreams?pageLimit=700&status=1${SearchKey}`
      )
      dispatch(setListOfDegree(result?.data?.data?.result || {}))

      return result
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getCourses = payload => async dispatch => {
  const baseConfig = systemConfig?.courses || {}

  // Construct filters
  let dynamicFilters = []
  let degreeFilters = []

  if (payload.searchType === 'ALL' || payload.searchValue == '') {
    // If searchType is ALL, send filters as an empty array
    dynamicFilters = []
  } else {
    if (payload.searchType) {
      // "DIPLOMA" is a TPO-facing bucket that also covers PG-diploma degrees (e.g. PGDM),
      // which are stored with type P_G_DIPLOMA (mirrors getEligibilityCriteriaQualification).
      if (payload.searchType === 'DIPLOMA') {
        degreeFilters.push(
          { field: 'type.keyword', value: 'DIPLOMA' },
          { field: 'type.keyword', value: 'P_G_DIPLOMA' },
        )
      } else {
        degreeFilters.push({
          field: 'type.keyword',
          value: payload?.searchType,
        })
      }
    }

    if (payload.searchValue) {
      dynamicFilters.push({
        field: 'status',
        value: 1,
      })
    }
  }

  const finalPayload = {
    ...baseConfig,
    q: payload.searchValue || '',
    filters: dynamicFilters,
    should: degreeFilters || [],
  }
  console.log(finalPayload,payload,' :finalPayload')
  try {
    const result = await elasticSearchRequest.post(
      `search/degrees/streams/specialisations`,
      finalPayload
    )

    let data = result.data.data || []
    return data
  } catch (error) {
    ErrorMessage(error?.message)
  }
}

export const getEligibilityCriteriaQualification =
  ({ searchValue, searchType = 'ALL', searchField, callEndPoint }) =>
  async (dispatch, getState) => {
    let filters = [
      {
        field: 'type.keyword',
        value: searchField,
      },
      {
        field: 'status.keyword',
        value: '1',
      },
    ]
    let diplomaFilters = [
      {
        field: 'status.keyword',
        value: '1',
      },
    ]
    let addAbout = [
      {
        field: 'type.keyword',
        value: 'DIPLOMA',
      },
      {
        field: 'type.keyword',
        value: 'P_G_DIPLOMA',
      },
    ]
    if (
      (searchValue && searchType == 'STREAM') ||
      searchType == 'SPECIALISATION'
    ) {
      searchValue = searchValue.toLowerCase()
    }
    let payLoad = systemConfig?.degree_streams_specialisation
    payLoad.q = searchValue || ''
    payLoad.searchType = searchType
    payLoad.filters = searchField == 'DIPLOMA' ? diplomaFilters : filters
    payLoad.should = searchField == 'DIPLOMA' ? addAbout : []
    try {
      const endpoint = `/search/degrees/streams/specialisations`
      const result = await elasticSearchRequest.post(endpoint, payLoad)
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getElasticSearchDegreeData =
  ({ searchValue }) =>
  async dispatch => {
    let payLoad = systemConfig?.degree_streams
    payLoad.q = searchValue || ''
    try {
      const result = await elasticSearchRequest.post(
        `/search/degrees/streams`,
        payLoad
      )

      let data = result.data.data?.hits?.hits
      dispatch(setElasticSearchDegreeData(data || {}))

      return result
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const searchAPI = (type, search, payload) => async () => {
  try {
    let result
    if (type === 'skills') {
      const response = await elasticSearchRequest.get('/students/crud/skill', {
        params: {
          page: 1,
          pageLimit: 10000,
          ...(search?.trim() ? { search: search.trim() } : {}),
          isActive: true,
          status: 1,
          order: 'asc',
        },
      })
      result = response?.data?.data?.result
    } else {
      const response = await elasticSearchRequest.post(`/search/${type}`, {
        ...payload,
        name: undefined,
        q: search,
      })
      result = response?.data?.data?.hits?.hits?.map(item => item?._source)
    }
    return result
  } catch (error) {
    ErrorMessage(`Error in getting list of ${type}`)
    return []
  }
}

export const getListOfSkills = search => async dispatch => {
  let payLoad = systemConfig?.skills
  payLoad.q = search || ''

  try {
    const result = await elasticSearchRequest.get('/students/crud/skill', {
      params: {
        page: 0,
        pageLimit: 10000,
        ...(search?.trim() ? { search: search.trim() } : {}),
        isActive: true,
        status: 1,
        order: 'asc',
      },
    })
    // const result = await elasticSearchRequest.post(`/search/skills`, payLoad)
    // Add mandatory: false to each skill object
    let data = result?.data?.data?.result?.map(item => ({
      // ...item?._source,
      isMandatory: false,
      // skillId: item?.id,
      // skillName: item?.name,
      id: item?.id,
      name: item?.name,
      // option: {
      //   // ...item?._source,
      //   mandatory: false,
      // skillId: item?._source?.id,
      //   skillName: item?._source?.name,
      // },
    }))
    if (data.length === 0 && search) {
      data.push({
        isMandatory: false,
        // skillId: search,
        // skillName: search,
        id: search,
        name: search,
        isNew: true,
      })
    }
    // dispatch(setSkillsList(data))
    return data
  } catch (error) {
    ErrorMessage(error?.message)
    dispatch(setSkillsList({}))
  }
}

export const getRoleRankingConfig = roleId => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporate/role/${roleId}/roleRankConfig`
    )
    dispatch(setRankingConfigData(response?.data?.data))
    if (response?.status >= 200 && response?.status <= 300) return true
  } catch (error) {
    //
  }
}

export const updateRoleRankingConfig = (roleId, payload) => async () => {
  try {
    const response = await corporateRequest.put(
      `/corporate/role/${roleId}/roleRankConfig`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const questionarieShortlistReject = (roleId, payload) => async () => {
  try {
    const response = await studentRequest.put(
      `/students/role/${roleId}/updatestatus`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const getCities =
  ({ searchValue }) =>
  async dispatch => {
    let SearchKey = searchValue ? `&search=${searchValue}` : ''

    try {
      const result = await elasticSearchRequest.get(
        `cities?pageLimit=50&currentPage=1${SearchKey}`
      )
      dispatch(setCityList(result?.data?.data))

      return result
    } catch (error) {
      ErrorMessage(error?.message)
      dispatch(setCityList([]))
    }
  }

export const createDrive = payload => async () => {
  try {
    const result = await corporateRequest.post(
      `/corporates/jobdrive/apply`,
      payload
    )
    return result
  } catch (error) {
    return error?.response
  }
}
export const getInstituteCampusDetails =
  ({ instituteCampusId }) =>
  async dispatch => {
    try {
      const result = await instituteRequest.get(
        `institutes/instituteCampus/${instituteCampusId}`
      )
      dispatch(setInstituteCampusDetails(result?.data?.data))

      return result
    } catch (error) {
      ErrorMessage(error?.message)
      dispatch(setInstituteCampusDetails({}))
    }
  }

export const getDriveRoleMetrics =
  ({ setLoading, driveId }) =>
  async dispatch => {
    try {
      setLoading(true)
      const result = await corporateRequest.get(
        `corporates/${driveId}/roles/metrics`
      )

      dispatch(setDriveRoleMetrics(result?.data?.data))
      setLoading(false)
      return result
    } catch (error) {
      ErrorMessage(error?.message)
      dispatch(setDriveRoleMetrics([]))
      setLoading(false)
    }
  }

export const getApplicantCandidateList =
  ({
    roleId,
    setLoading,
    searchValue,
    sortby,
    orderby,
    filterData,
    pageLimit,
    pageNum = 0,
    statusCand,
    stage,
    offerStatus,
    driveStatus,
    checkedIds,
  }) =>
  async dispatch => {
    let sort = sortby ? `&sort=${sortby}` : ''
    let orderBy = orderby ? `&order=${orderby}` : ''
    let pageNo = searchValue ? 0 : pageNum ? pageNum - 1 : 0
    let searchKey = searchValue ? `&searchBy=${searchValue}` : ''
    let city = filterData?.location ? `&location=${filterData?.location}` : ''
    let collegeName = filterData?.collegeName
      ? `&collegeName=${filterData?.collegeName}`
      : ''

    let rate = filterData?.rating?.minValue?.toString()
      ? `&fromRating=${filterData?.rating?.minValue?.toString()}`
      : ''
    let maxRate = filterData?.rating?.maxValue?.toString()
      ? `&toRating=${filterData?.rating?.maxValue?.toString()}`
      : ''
    let offer = offerStatus ? `&offerStatus=${offerStatus}` : ''
    let drive = driveStatus ? `&driveStatus=${driveStatus}` : ''
    let stages = stage ? `&stage=${stage}` : ''
    let statusCandidate = statusCand ? `&status=${statusCand}` : ''
    let degree =
      checkedIds?.length > 0 ? `&degreeStreamMapIds=${checkedIds}` : ''
    try {
      setLoading(true)
      const result = await studentRequest.get(
        `/students/role/${roleId}/applicant/list?pageLimit=${pageLimit}&pageNo=${pageNo}${searchKey}${sort}${orderBy}${statusCandidate}${city}${collegeName}${stages}${offer}${drive}${degree}`
      )

      dispatch(setApplicantCandidateList(result?.data?.data))
      setLoading(false)
      return result
    } catch (error) {
      ErrorMessage(error?.message)
      dispatch(setApplicantCandidateList([]))
      setLoading(false)
    }
  }

export const getStudentQuestionaireList =
  ({
    roleId,
    setLoading,
    status,
    searchValue,
    sortby,
    orderby,
    filterData,
    pageNum = 0,
    statusCand,
    stage,
    offerStatus,
    driveStatus,
    checkedIds,
    isExpCandidate,
  }) =>
  async dispatch => {
    let appliedStatus = status ? `&isApplied=${status}` : ''
    let ExpCandidate = isExpCandidate ? `&isExpCandidate=${isExpCandidate}` : ''
    let sort = sortby ? `&sort=${sortby}` : ''
    let orderBy = orderby ? `&order=${orderby}` : ''
    let pageNo = searchValue ? 0 : pageNum ? pageNum - 1 : 0
    let searchKey = searchValue ? `&searchBy=${searchValue}` : ''
    let city = filterData?.location ? `&location=${filterData?.location}` : ''
    let collegeName = filterData?.instituteCampusIds
      ? `&instituteCampusIds=${filterData?.instituteCampusIds}`
      : ''
    let company = filterData?.latestCompany
      ? `&latestCompany=${filterData?.latestCompany}`
      : ''
    let role = filterData?.latestRole
      ? `&latestRole=${filterData?.latestRole}`
      : ''
    let rate = filterData?.rating?.minValue?.toString()
      ? `&fromRating=${filterData?.rating?.minValue?.toString()}`
      : ''
    let maxRate = filterData?.rating?.maxValue?.toString()
      ? `&toRating=${filterData?.rating?.maxValue?.toString()}`
      : ''
    let exp = filterData?.yearOfEx?.minValue?.toString()
      ? `&fromExperience=${filterData?.yearOfEx?.minValue?.toString()}`
      : ''
    let maxExp = filterData?.yearOfEx?.maxValue?.toString()
      ? `&toExperience=${filterData?.yearOfEx?.maxValue?.toString()}`
      : ''
    let offer = offerStatus ? `&offerStatus=${offerStatus}` : ''
    let drive = driveStatus ? `&driveStatus=${driveStatus}` : ''
    let stages = stage ? `&stage=${stage}` : ''
    let statusCandidate = statusCand ? `&status=${statusCand}` : ''
    let degree =
      checkedIds?.length > 0 ? `&degreeStreamMapIds=${checkedIds}` : ''
    try {
      setLoading(true)
      const result = await studentRequest.get(
        `/students/role/${roleId}/studentquestionairelist?pageLimit=10&pageNo=${pageNo}${ExpCandidate}${appliedStatus}${searchKey}${sort}${orderBy}${statusCandidate}${city}${collegeName}${stages}${offer}${drive}${maxExp}${exp}${degree}${company}${role}`
      )
      dispatch(setQuestionnierDBList(result?.data?.data))
      setLoading(false)
      return result
    } catch (error) {
      ErrorMessage(error?.message)
      dispatch(setQuestionnierDBList([]))
      setLoading(false)
    }
  }

export const getDesignationsList =
  ({
    // setLoadingState,
    searchValue,
    functionId,
    pageNum = '1',
    pageLimit = '20',
  }) =>
  async dispatch => {
    let SearchKey = searchValue ? `&search=${searchValue}` : ''
    let funcId = functionId ? `&functionId=${functionId}` : ''
    try {
      // setLoadingState(true)
      const result = await corporateRequest.get(
        `designations?currentPage=${pageNum}&pageLimit=${pageLimit}${funcId}${SearchKey}`
      )
      // dispatch(setDesignationsList(result?.data?.data))
      // setLoadingState(false)
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
      // dispatch(setDesignationsList({}))
      // setLoadingState(false)
    }
  }

export const getFunctionsList =
  ({ setLoading, searchValue, pageNum = '0', pageLimit = '20' }) =>
  async dispatch => {
    let SearchKey = searchValue ? `search=${searchValue}` : ''

    try {
      setLoading(true)
      const result = await corporateRequest.get(
        `/corporate/search/functions?${SearchKey}&pageNo=${pageNum}&pageLimit=${pageLimit}`
      )

      dispatch(setFunctionsList(result?.data?.data))
      setLoading(false)
      return result
    } catch (error) {
      ErrorMessage(error?.message)
      dispatch(setFunctionsList({}))
      setLoading(false)
    }
  }
// `roleId` scopes the fetch to one application: student-node then returns the
// profile frozen when the candidate entered that role (Applied Role Snapshot)
// rather than their live one, so editing a score no longer rewrites what the
// drawer shows for an application already submitted. Omitted from screens with
// no role context (e.g. the notification drawer), which stay live.
export const getCandidateDetails =
  ({ studentId, roleId, setLoading }) =>
  async dispatch => {
    try {
      if (setLoading) {
        setLoading(true)
      }

      const result = await studentRequest.get(
        `students/${studentId}${roleId ? `?roleId=${encodeURIComponent(roleId)}` : ''}`
      )
      dispatch(setCandidateDetails(result?.data?.data))
      if (setLoading) {
        setLoading(false)
      }
      return result
    } catch (error) {
      if (setLoading) {
        setLoading(false)
      }
      ErrorMessage(error?.message)
      dispatch(setCandidateDetails({}))
      if (setLoading) {
        setLoading(false)
      }
    }
  }

export const getEvaluationDetails = (roleId, studentId) => async dispatch => {
  try {
    const result = await corporateRequest.get(
      `corporate/evaluation/${roleId}/${studentId}`
    )
    dispatch(setEvaluationDetails(result?.data?.data))
    return result
  } catch (error) {
    ErrorMessage(error?.message)
    dispatch(setEvaluationDetails({}))
  }
}

export const getQuestionnaireDetails =
  (roleId, status, isExpCandidate) => async dispatch => {
    let appliedStatus = status ? `&isApplied=${status}` : ''
    let ExpCandidate = isExpCandidate ? `isExpCandidate=${isExpCandidate}` : ''

    try {
      const result = await studentRequest.get(
        `students/role/${roleId}/expcand/questionaire/filter/list?${ExpCandidate}${appliedStatus}`
      )
      dispatch(setQuestionnaireDetails(result?.data?.data))
      return result
    } catch (error) {
      ErrorMessage(error?.message)
      dispatch(setQuestionnaireDetails({}))
    }
  }

export const getPromotion = studentId => async dispatch => {
  if (!studentId) {
    return null
  }
  
  try {
    const response = await studentRequest.get(
      `/students/${studentId}/promotion`
    )
    dispatch(setPromotionData(response.data.data))
    return response
  } catch (error) {
    return error
  }
}

export const getStdRankAlgoData = (roleId, studentId) => async dispatch => {
  try {
    const response = await studentRequest.get(
      `/students/${studentId}/role/${roleId}/rankingalorithm`
    )
    dispatch(setStdRankData(response?.data?.data))
    return response
  } catch (error) {
    return error
  }
}

export const addRoleToExistingDrive =
  ({ setLoading, roleId, driveId, payload }) =>
  async () => {
    try {
      setLoading(true)
      const result = await corporateRequest.post(
        `corporates/role/${roleId}/drive/${driveId}/addRoleInExistingDrive`,
        payload
      )
      setLoading(false)
      SuccessMessage('Role Added Successfully.')
      return result
    } catch (error) {
      ErrorMessage(error?.message)
      setLoading(false)
    }
  }

export const getRoleAppliedDriveMetrics = roleId => async dispatch => {
  try {
    const result = await corporateRequest.get(
      `/corporates/${roleId}/drive/metrics`
    )
    dispatch(setRoleAppliedDriveMetrics(result?.data?.data || {}))
    return result
  } catch (error) {
    return error
  }
}

export const getIndustries =
  ({ pageNum = '1', pageLimit = '15', searchValue }) =>
  async dispatch => {
    let SearchKey = searchValue ? `&search=${searchValue}` : ''

    try {
      const result = await corporateRequest.get(
        `/industries?currentPage=${pageNum}&pageLimit=${pageLimit}${SearchKey}`
      )
      dispatch(setIndustriesList(result?.data?.data || {}))
      return result
    } catch (error) {
      return error
    }
  }

export const getSpecialisationList = payload => async dispatch => {
  try {
    const result = await instituteRequest.post(
      `/institutes/specialitationList`,
      payload
    )
    dispatch(setSpecialisationList(result?.data?.data || []))
    return result
  } catch (error) {
    ErrorMessage(error?.message)
    return error?.response
  }
}
export const getJobRoleCampusList =
  ({ jobId, currentPageNo = 1, pageLimit = 500 }) =>
  async dispatch => {
    try {
      const result = await instituteRequest.get(
        `/institutes/role/${jobId}/campus/list?pageLimit=${pageLimit}&currentPage=${currentPageNo}`
      )
      dispatch(setJobRoleCampusList(result?.data?.data || {}))
      return result
    } catch (error) {
      return error?.response
    }
  }

export const getDegreesBasedOnRoles =
  ({ jobId }) =>
  async dispatch => {
    try {
      const result = await corporateRequest.get(
        `/corporate/role/${jobId}/degree`
      )
      dispatch(setDegreesBasedOnRoles(result?.data?.data || []))
      return result
    } catch (error) {
      dispatch(setDegreesBasedOnRoles([]))
      return error?.response
    }
  }

export const getDegreesBasedExRoles =
  ({ jobId }) =>
  async dispatch => {
    try {
      const result = await studentRequest.get(
        `/exstudents/roles/${jobId}/mappedExDegree/list`
      )
      dispatch(setDegreesBasedExRoles(result?.data?.data || []))
      return result
    } catch (error) {
      dispatch(setDegreesBasedExRoles([]))
      return error?.response
    }
  }

export const getCollegeBasedOnATS =
  ({ jobId }) =>
  async dispatch => {
    try {
      const result = await studentRequest.get(
        `/students/role/${jobId}/applicantcollege/list`
      )
      dispatch(setCollegeBasedOnATS(result?.data?.data || []))
      return result
    } catch (error) {
      dispatch(setCollegeBasedOnATS([]))
      return error?.response
    }
  }

export const getLocationBasedOnATS =
  ({ jobId }) =>
  async dispatch => {
    try {
      const result = await studentRequest.get(
        `/students/role/${jobId}/applicantlocation/list`
      )
      dispatch(setLocationBasedOnATS(result?.data?.data || []))
      return result
    } catch (error) {
      dispatch(setLocationBasedOnATS([]))
      return error?.response
    }
  }

export const getDegreeBasedOnATS =
  ({ jobId }) =>
  async dispatch => {
    try {
      const result = await studentRequest.get(
        `/students/roles/${jobId}/applicationDegree/list`
      )
      dispatch(setDegreeBasedOnATS(result?.data?.data?.result || []))
      return result
    } catch (error) {
      dispatch(setDegreeBasedOnATS([]))
      return error?.response
    }
  }

export const getCollegeBasedOnQuestionnier =
  ({ jobId }) =>
  async dispatch => {
    try {
      const result = await studentRequest.get(
        `/students/roles/${jobId}/mappedCampus/list`
      )
      dispatch(setCollegeBasedOnQuestionnier(result?.data?.data?.result || []))
      return result
    } catch (error) {
      dispatch(setCollegeBasedOnQuestionnier([]))

      return error?.response
    }
  }

export const getDegreeBasedOnQuestionnier =
  ({ jobId }) =>
  async dispatch => {
    try {
      const result = await studentRequest.get(
        `/students/roles/${jobId}/mappedDegree/list`
      )
      dispatch(setDegreeBasedOnQuestionnier(result?.data?.data?.result || []))
      return result
    } catch (error) {
      dispatch(setDegreeBasedOnQuestionnier([]))
      return error?.response
    }
  }

export const jobSharingEmail =
  ({ setLoading, payload }) =>
  async (dispatch, getState) => {
    const state = getState()
    const userId = authSelector.getUserId(state)
    try {
      setLoading(true)
      const result = await authRequest.post(
        `/users/${userId}/jobSharing`,
        payload
      )
      setLoading(false)
      SuccessMessage('E-mail Send Successfully.')
      return result
    } catch (error) {
      ErrorMessage(error?.message)
      setLoading(false)
    }
  }

export const getRoleViewCard =
  ({ data, roleId }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const corporate_id = authSelector.getCorporateId(state)
      const result = await studentRequest.get(
        `/students/corporate/${corporate_id}/roles/${roleId}/metrices`,
        data
      )
      dispatch(setRoleViewCard(result?.data?.data || {}))
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error?.response
    }
  }

export const getRoleViewCardATS =
  ({ data, roleId }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const corporate_id = authSelector.getCorporateId(state)
      const result = await studentRequest.get(
        `/students/corporate/${corporate_id}/roles/${roleId}/atsmetrices`,
        data
      )
      dispatch(setRoleViewCardATS(result?.data?.data || {}))
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error?.response
    }
  }

export const getRoleViewChart =
  ({ data, roleId }) =>
  async dispatch => {
    try {
      const result = await studentRequest.get(
        `/students/corporate/roles/${roleId}/drive/metrices`,
        data
      )
      dispatch(setRoleViewChart(result?.data?.data || {}))
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error?.response
    }
  }

export const getAppliedCandidateListTrue =
  ({
    roleId,
    searchValue,
    sortby,
    orderby,
    filterData,
    searchByRating,
    searchByPercentage,
    searchByDegree,
    pageLimit = 10,
    pageNum = 0,
    instituteCampusIds,
    isListForDriveCreate = '',
    candidateIds = [],
    shortListDrawer,
    newPreviewDrawer,
    confirmDrawer,
    setShortListDrawerDetails,
    candidateRangeMin,
    candidateRangeMax,
    prefferedlocationStatus,
    prefferedLocations,
    currentLocationStatus,
    cities,
  }) =>
  async dispatch => {
    let rate = filterData?.rating?.minValue?.toString()
      ? `&fromRating=${filterData?.rating?.minValue?.toString()}`
      : ''
    let maxRate = filterData?.rating?.maxValue?.toString()
      ? `&toRating=${filterData?.rating?.maxValue?.toString()}`
      : ''
    let rating =
      filterData?.rating && shortListDrawer
        ? `&rating=${filterData?.rating}`
        : ''
    let searchByRate = searchByRating ? `&rating=${searchByRating}` : ''

    let status = filterData?.status ? `&status=${filterData?.status}` : ''
    let payload = filterData?.degreeDepartment?.length
      ? {
          degreeStreamMapIds: filterData?.degreeDepartment?.toString(),
        }
      : searchByDegree?.length
      ? {
          degreeStreamMapIds: searchByDegree?.toString(),
        }
      : {}
    if (instituteCampusIds) {
      payload.instituteCampusIds = instituteCampusIds
    }

    let workExperience = ''
    if (candidateRangeMax > 0) {
      workExperience = `&workExperience=${candidateRangeMin},${candidateRangeMax}`
    }
    let searchPercentage = searchByPercentage
      ? `&percentage=${searchByPercentage}`
      : ''

    let prefferedLocation = ''
    if (prefferedlocationStatus && prefferedLocations?.length) {
      prefferedLocation = `&preferredLocation=${prefferedLocations}`
    }
    let currentLocation = ''
    if (currentLocationStatus) {
      currentLocation = `&currentLocation=${currentLocationStatus}`
      payload.cities = cities
    }
    let instituteIds = filterData?.collegeName
      ? `&institutecampusIds=${filterData?.collegeName}`
      : ''
    let searchKey = searchValue ? `&searchBy=${searchValue.trim()}` : ''

    let gender = filterData?.gender ? `&gender=${filterData?.gender}` : ''
    let sort = sortby ? `&sort=${sortby}` : ''
    let orderBy = orderby ? `&order=${orderby}` : ''
    let isExpCandidate = `&isExpCandidate=${true}`
    let pageNo = searchValue ? 0 : pageNum ? pageNum - 1 : 0
    let isListForDriveCreateQ = isListForDriveCreate
      ? `&isListForDriveCreate=${isListForDriveCreate}`
      : ''

    if (shortListDrawer && candidateIds?.length) {
      payload.candidateIds = candidateIds
    }
    try {
      const result = await studentRequest.post(
        `/students/roles/${roleId}/candidate/list?pageLimit=${pageLimit}&pageNo=${pageNo}${searchKey}${sort}${orderBy}${status}${instituteIds}${searchByRate}${searchPercentage}${gender}${isListForDriveCreateQ}${isExpCandidate}${workExperience}${currentLocation}${prefferedLocation}`,
        payload
      )
      if (shortListDrawer || confirmDrawer || newPreviewDrawer) {
        setShortListDrawerDetails(result?.data?.data || {})
      } else {
        dispatch(setAppliedCandidatesListTrue(result?.data?.data || {}))
      }
      return result
    } catch (error) {
      dispatch(setAppliedCandidatesListTrue({}))
      ErrorMessage(error?.message)
    }
  }

export const createShortList = updatePayload => async (dispatch, getState) => {
  try {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    const payload = {
      jobDrive: {
        ...updatePayload,
        corporateId: corporate_id,
      },
    }
    const result = await corporateRequest.post(
      `/corporates/candidate/jobdrive/apply`,
      payload
    )
    return result
  } catch (error) {
    return error?.response
  }
}

export const exportCandidate =
  (roleId, selectedRound, selectedFileType, selectedColumn, format) =>
  async () => {
    try {
      const round = selectedRound ? `&stage=${selectedRound}` : ''
      const key =
        selectedColumn?.length > 0 ? `key=${selectedColumn.join(',')}` : ''

      const response = await studentRequest.get(
        `/students/roles/${roleId}/export/candidate/list/${format}?${key}${round}&type=${selectedFileType}`
      )
      return response
    } catch (error) {
      return error
    }
  }

export const exportCandidateQuestionnier =
  (roleId, selectedColumn, boolean, status) => async () => {
    try {
      let addedKey = ['candidateName', ...selectedColumn]
      const key = addedKey?.length > 0 ? `&keys=${addedKey?.join(',')}` : ''
      const roleStatus = status ? `&roleStatus=${status}` : ''
      const response = await studentRequest.get(
        `/students/role/${roleId}/export/candidate?isExpCandidate=${boolean}${key}${roleStatus}`
      )
      return response
    } catch (error) {
      return error
    }
  }

export const getRescheduleList =
  ({ driveId, roleId, studentId }) =>
  async dispatch => {
    try {
      const result = await studentRequest.get(
        `/students/drive/${driveId}/role/${roleId}/candidate/${studentId}`
      )
      dispatch(setRescheduleList(result?.data?.data?.candidate || {}))
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error?.response
    }
  }

export const getRoleRounds = roleId => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporates/role/${roleId}/expstudent/interview/rounds`
    )
    dispatch(setRoleRounds(response?.data?.data?.rounds || {}))
    return response
  } catch (error) {
    return error
  }
}

export const UpdateScheudle = (driveId, studentId, payload) => async () => {
  try {
    const response = await corporateRequest.put(
      `corporates/drive/${driveId}/candidate/${studentId}/update/interview`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const createQuestionarie =
  ({ jobId, payload }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const corporateId = authSelector.getCorporateId(state)

      const roleId = jobId

      const result = await corporateRequest.post(
        `/corporate/${corporateId}/role/${roleId}/questionarie`,
        payload
      )
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }

export const createQuestionarieBank =
  ({ roleId, bankPayload }) =>
  async () => {
    try {
      const result = await corporateRequest.post(
        `/corporate/role/${roleId}/questionarie`,
        bankPayload
      )
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }

export const editQuestionarie =
  ({ questionBankRoleMapId, updatePayload }) =>
  async () => {
    try {
      const result = await corporateRequest.put(
        `/corporate/questionarie/${questionBankRoleMapId}`,
        updatePayload
      )
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }

export const getAllQuestionarieList = (explicitJobId) => async (dispatch, getState) => {
  try {
    const state = getState()
    const jobId = explicitJobId || selectors.getCurrentJobId(state)
    if (!jobId) {
      dispatch(setAllQuestionarieList([]))
      return []
    }
    const result = await corporateRequest.get(
      `corporate/questionarie/list/${jobId}?forCorporate=true`
    )
    dispatch(setAllQuestionarieList(result?.data?.data?.result || {}))
    return result?.data?.data?.result
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
    return error?.response
  }
}

export const getAllQuestionBankList =
  (currentPage, limit = 10, job_id = '') =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const corporateId = authSelector.getCorporateId(state)
      const jobId = selectors.getCurrentJobId(state) || job_id
      if (!jobId) {
        console.warn('Job ID is missing. API call not triggered.')
        return
      }
      let pageNo = currentPage || 0
      const result = await corporateRequest.get(
        `/corporate/${corporateId}/questionBank/list?limit=${limit}&pageNo=${pageNo}&jobId=${jobId}`
      )
      dispatch(setAllQuestionBankList(result?.data?.data || {}))
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error?.response
    }
  }

export const deleteQuestion =
  ({ questionarieId }) =>
  async dispatch => {
    try {
      const result = await corporateRequest.delete(
        `/corporate/questionarie/${questionarieId}`
      )
      dispatch(getAllQuestionarieList())
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
    }
  }

export const getSingleQuestionarie =
  ({ questionarieId }) =>
  async dispatch => {
    try {
      const result = await corporateRequest.get(
        `/corporate/questionarie/${questionarieId}`
      )
      dispatch(setSingleQuestionarie(result?.data?.data || {}))
      return result
    } catch (error) {
      ErrorMessage(error?.response?.data?.message)
      return error?.response
    }
  }

export const getDriveNotCreatedCandidatesPoolDrive =
  ({ roleId, setLoading, searchValue, pageLimit, pageNo }) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    let payload = {
      type: 'DRIVE_NOT_CREATED',
    }

    let pageNoQ = pageNo
      ? `pageNo=${getPageNo(searchValue, pageNo)}`
      : `pageNo=0`
    let pageLimitQ = pageLimit ? `&pageLimit=${pageLimit}` : `&pageLimit=10`
    let query = `${pageNoQ}${pageLimitQ}`
    try {
      setLoading(true)
      const result = await instituteRequest.post(
        `institutes/corporate/${corporate_id}/role/${roleId}/jobRoleInstituteAndNameCount?${query}`,
        payload
      )
      setLoading(false)
      return result
    } catch (error) {
      setLoading(false)
      ErrorMessage(error?.message)
      return error
    }
  }

export const RejectRequest =
  (driveID, roleID, studentId, payload) => async () => {
    try {
      const result = await corporateRequest.put(
        `corporates/role/${roleID}/drive/${driveID}/candidate/${studentId}`,
        payload
      )
      SuccessMessage('Request Rejected Successfully')
      return result
    } catch (error) {
      return error?.response
    }
  }
export const getRoleDataToExport =
  (roleId, setLoadingRole, filterData, sort, order) => async dispatch => {
    setLoadingRole(true)

    let rate = filterData?.rating?.minValue?.toString()
      ? `&fromRating=${filterData?.rating?.minValue?.toString()}`
      : ''
    let maxRate = filterData?.rating?.maxValue?.toString()
      ? `&toRating=${filterData?.rating?.maxValue?.toString()}`
      : ''
    let status = filterData?.status ? `&status=${filterData?.status}` : ''

    let instituteIds = filterData?.collegeName
      ? `&institutecampusIds=${filterData?.collegeName}`
      : ''

    let gender = filterData?.gender ? `&gender=${filterData?.gender}` : ''
    let isExpCandidate = `&isExpCandidate=${false}`
    let BASE_URL = `/appliedstudents/list/${roleId}`
    let payload = filterData?.degreeDepartment?.length
      ? {
          degreeStreamMapIds: filterData?.degreeDepartment?.toString(),
        }
      : {}
    let sortBy = sort ? `&sort=${sort}` : ''
    let orderBy = order ? `&order=${order}` : ''
    try {
      const response = await studentRequest.post(
        `${BASE_URL}?page=0${status}${instituteIds}${gender}${isExpCandidate}${sortBy}${orderBy}`,
        payload
      )
      dispatch(setRoleDataToExcel(response?.data?.data || []))

      setLoadingRole(false)
    } catch (error) {
      if (setLoadingRole) {
        setLoadingRole(false)
      }
    }
  }

export const UpdateDriveEndDate = (driveID, payload) => async () => {
  try {
    const result = await corporateRequest.patch(
      `corporates/drive/${driveID}/updateDriveEndDate`,
      payload
    )
    SuccessMessage('Drive End Date Update Successfully')
    return result
  } catch (error) {
    return error?.response
  }
}

export const addCollegeToExistingDrive = payload => async () => {
  try {
    const result = await corporateRequest.post(
      `corporates/jobdrive/addCollegeToExistingDrive`,
      payload
    )
    SuccessMessage('College Added Successfully')
    return result
  } catch (error) {
    return error?.response
  }
}

export const getUniqueStudentInstitutesList =
  ({
    searchValue = '',
    limit = 10,
    pageNum = 0,
    setLoading,
    locationValue = '',
    tierValue = '',
    isForRole = false,
  }) =>
  async (dispatch, getState) => {
    setLoading(true)
    let SearchKey = searchValue ? `&searchBy=${searchValue}` : ''

    let pageNo = 0
    if (isForRole) {
      pageNo = pageNum
    } else {
      pageNo = searchValue ? 0 : pageNum
    }
    let location = locationValue ? `&location=${locationValue}` : ''
    let tier = tierValue ? `&tier=${tierValue}` : ''
    const state = getState()
    const job_id = roleSelector.getCurrentJobId(state)
    try {
      const res = await studentRequest.get(
        `/students/roles/${job_id}/mappedCampus/list?pageLimit=${limit}&pageNo=${pageNo}${SearchKey}${location}${tier}`
      )

      setLoading(false)
      return res
    } catch (error) {
      setInstitutesList([])
      setLoading(false)
      return error?.response
    }
  }

export const getLocations =
  ({ searchValue }) =>
  async dispatch => {
    let SearchKey = searchValue ? `search=${searchValue}` : ''
    const { COUNTRY_ID } = process.env
    try {
      const result = await elasticSearchRequest.get(
        `search/states/cities?${SearchKey}&countryId=${COUNTRY_ID}`
      )
      const newOptions = [
        ...result?.data?.data?.cities?.map(city => ({
          id: city.city_id,
          name: city.city_name,
          type: 'city',
          option: {
            id: city.city_id,
            name: city.city_name,
            state_id: city.state_id,
            state_name: city.state_name,
          },
        })),
        ...result?.data?.data?.states?.map(state => ({
          id: state.state_id,
          name: state.state_name,
          type: 'state',
          option: {
            state_id: state.state_id,
            state_name: state.state_name,
          },
        })),
      ]
      // dispatch(setListOfLocation(newOptions))

      return newOptions
    } catch (error) {
      console.log('Error in getting list of degree =>', error?.message)
      // dispatch(setListOfLocation([]))
    }
  }

export const createGroup = payload => async (dispatch, getState) => {
  try {
    const corporateId = authSelector.getCorporateId(getState())
    const result = await instituteRequest.post(
      `/corporate/${corporateId}/instituteGroup`,
      payload
    )
    SuccessMessage('Group created successfully')
    return result
  } catch (error) {
    return error
  }
}

export const groupInstituteListFilter =
  (groupId, citySearch, stateSearch) => async (dispatch, getState) => {
    try {
      let cityQuery = ''
      let stateQuery = ''
      if (citySearch) {
        cityQuery = `&citySearch=${citySearch}`
      }
      if (stateSearch) {
        stateQuery = `&stateSearch=${stateSearch}`
      }
      const corporateId = authSelector.getCorporateId(getState())
      const result = await instituteRequest.get(
        `/corporate/${corporateId}/instituteGroup/filter?groupId=${groupId}${stateQuery}${cityQuery}`
      )

      return result?.data?.data
    } catch (error) {
      return error?.response
    }
  }

export const updateGroup = payload => async (dispatch, getState) => {
  try {
    const corporateId = authSelector.getCorporateId(getState())

    const result = await instituteRequest.put(
      `/instituteGroup/${corporateId}`,
      payload
    )
    SuccessMessage('Group updated successfully')
    return result
  } catch (error) {
    return error?.response
  }
}
export const removeInstituteFromGroup =
  payload => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const result = await instituteRequest.put(
        `/instituteGroup/${corporateId}/remove`,
        payload
      )
      SuccessMessage('Group updated successfully')
      return result
    } catch (error) {
      return error?.response
    }
  }
export const deleteGroup = groupId => async (dispatch, getState) => {
  try {
    const corporateId = authSelector.getCorporateId(getState())

    const result = await instituteRequest.delete(
      `/instituteGroup/${corporateId}/${groupId}`
    )
    SuccessMessage('Group deleted successfully')
    return result
  } catch (error) {
    return error?.response
  }
}
export const oneGroupDetail = payload => async (dispatch, getState) => {
  try {
    let stateQuery = ''
    let cityQuery = ''
    let tierQuery = ''
    let searchQuery = ''
    let pilRecommendedQuery = ''
    let pageLimitQuery = ''
    let pageNoQuery = ''
    if (payload?.stateId) {
      stateQuery = `&stateId=${payload.stateId}`
    }
    if (payload?.cityId) {
      cityQuery = `&cityId=${payload.cityId}`
    }
    if (payload?.tier) {
      tierQuery = `&tier=${payload.tier}`
    }
    if (payload?.search) {
      searchQuery = `&search=${payload.search?.trim()}`
    }
    if (payload?.pilRecommended) {
      pilRecommendedQuery = `&pilRecommended=${payload.pilRecommended}`
    }
    if (payload?.pageNo) {
      pageNoQuery = `&pageNo=${payload.pageNo}`
    }
    if (payload?.pageLimit) {
      pageLimitQuery = `&pageLimit=${payload.pageLimit}`
    }
    const corporateId = authSelector.getCorporateId(getState())
    const result = await instituteRequest.get(
      `/corporate/${corporateId}/instituteGroup?groupId=${payload?.groupId}${stateQuery}${cityQuery}${tierQuery}${pilRecommendedQuery}${searchQuery}${pageLimitQuery}${pageNoQuery}`
    )
    return result?.data?.data
  } catch (error) {
    return error?.response
  }
}

export const instituteGroupList = payload => async (dispatch, getState) => {
  try {
    let searchQuery = ''
    let pageNoQuery = ''
    let pageLimitQuery = ''
    let allGroupsQuery = ''
    let sortQuery = ''
    let orderByQuery = ''

    if (payload?.search) {
      searchQuery = `&search=${payload?.search}`
    }
    if (payload?.pageLimit) {
      pageLimitQuery = `&pageLimit=${payload?.pageLimit}`
    }
    if (payload?.pageNo) {
      pageNoQuery = `?pageNo=${payload?.pageNo}`
    }
    if (payload?.allGroups) {
      allGroupsQuery = `&allGroups=${payload?.allGroups}`
    }
    if (payload?.sort) {
      sortQuery = `&sort=${payload?.sort}`
    }
    if (payload?.orderBy) {
      orderByQuery = `&orderBy=${payload?.orderBy}`
    }
    const corporateId = authSelector.getCorporateId(getState())
    const result = await instituteRequest.get(
      `/instituteGroupList/${corporateId}${pageNoQuery}${pageLimitQuery}${searchQuery}${allGroupsQuery}${orderByQuery}${sortQuery}`
    )
    return result?.data?.data
  } catch (error) {
    return error?.response
  }
}

export const getMatchedInstituteList =
  payload => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const result = await instituteRequest.post(
        `/corporate/${corporateId}/instituteCampusDetails`,
        payload
      )
      return result?.data?.data
    } catch (error) {
      return error?.response
    }
  }
export const getMatchedInstituteListFilter =
  payload => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const result = await instituteRequest.post(
        `/corporate/${corporateId}/instituteCampusDetails/filter`,
        payload
      )
      return result?.data?.data
    } catch (error) {
      return error?.response
    }
  }
export const createDraftSelectInstitute =
  payload => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const result = await instituteRequest.post(
        `/corporate/${corporateId}/draftSelectInstitute`,
        payload
      )
      return result?.data?.data
    } catch (error) {
      return error?.response
    }
  }

export const getSelectedInstitutes = payload => async (dispatch, getState) => {
  try {
    if (payload?.selectedTiers?.length) {
      payload.tier = payload?.selectedTiers
    }
    if (payload?.selectedCities?.length) {
      payload.city = payload?.selectedCities
    }
    if (payload?.selectedStates?.length) {
      payload.state = payload?.selectedStates
    }
    if (payload?.pilRecommended) {
      payload.pilRecommended = payload?.pilRecommended
    }

    const corporateId = authSelector.getCorporateId(getState())
    const result = await instituteRequest.post(
      `/corprorate/${corporateId}/draftSelect/instituteCampusDetails`,
      payload
    )
    return result?.data?.data
  } catch (error) {
    return error?.response
  }
}

export const getSelectedInstitutesFilter =
  payload => async (dispatch, getState) => {
    try {
      // Build query string robustly
      let params = new URLSearchParams()
      if (payload?.stateSearch)
        params.append('stateSearch', payload.stateSearch)
      if (payload?.citySearch) params.append('citySearch', payload.citySearch)
      const queryString = params.toString() ? `?${params.toString()}` : ''
      const corporateId = authSelector.getCorporateId(getState())
      const result = await instituteRequest.get(
        `/corprorate/${corporateId}/draftSelect/instituteCampusDetails/filter${queryString}`
      )
      return result?.data?.data
    } catch (error) {
      return error?.response
    }
  }

export const createCorporateInstituteDetails =
  payload => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const result = await instituteRequest.post(
        `/corporate/${corporateId}/instituteDetails`,
        payload
      )
      return result?.data?.data
    } catch (error) {
      return error?.response
    }
  }
export const updateCorporateInstituteDetails =
  (payload, instituteCampusId) => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const result = await instituteRequest.put(
        `/corporate/${corporateId}/instituteDetails/${instituteCampusId}`,
        payload
      )
      return result?.data?.data
    } catch (error) {
      return error?.response
    }
  }

// /corporate/:corporateId/duplicateInstituteGroup/:id

export const dublicateGroup =
  (payload, groupId) => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const result = await instituteRequest.post(
        `/corporate/${corporateId}/duplicateInstituteGroup/${groupId}`,
        payload
      )
      SuccessMessage('Duplicate group created successfully')

      return result?.data?.data
    } catch (error) {
      return error?.response
    }
  }
export const getMapMetrics = payload => async (dispatch, getState) => {
  try {
    const corporateId = authSelector.getCorporateId(getState())
    const result = await instituteRequest.post(
      `/corporate/${corporateId}/map/metrics`,
      payload
    )

    return result?.data?.data
  } catch (error) {
    return error?.response
  }
}
export const publishRole = (roleId, payload) => async (dispatch, getState) => {
  try {
    const corporateId = authSelector.getCorporateId(getState())
    payload.corporateId = corporateId
    const result = await corporateRequest.post(
      `/corporates/jobs/${roleId}/publish`,
      payload
    )

    return result?.data
  } catch (error) {
    return error?.response
  }
}

export const deleteSelectedDraftInstitute =
  payload => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      payload.corporateId = corporateId
      const result = await instituteRequest.post(
        `/corprorate/${corporateId}/draftSelect/delete`,
        payload
      )

      return result?.data
    } catch (error) {
      return error?.response
    }
  }
export const getStepper = (roleId, payload) => async (dispatch, getState) => {
  try {
    const corporateId = authSelector.getCorporateId(getState())
    const result = await corporateRequest.put(
      `/corporates/${corporateId}/jobs/${roleId}/stepUpdate`,
      payload
    )
    return result?.data?.data
  } catch (error) {
    return error?.response
  }
}
